<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import Vue3Html2pdf from 'vue3-html2pdf';
import TaxInvoicePdf from "./taxInvoicePdf.vue";
import { ref } from 'vue';
import Loading from 'vue-loading-overlay';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    invoiceTax: Object,
    agent: Object,
    flash: Object,
    user: Object,
});

let html2Pdf = ref();
let isLoading = ref(false);
dayjs.extend(advancedFormat);

//currency formatter
function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//currency formatter and remove decimal to round off
function formatPriceRoundOff(value) {
    let val = (value / 1).toFixed(0).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// function to generate pdf using vue - html2pdf and InvoicePdf component ref html2Pdf
let options = {
    margin: 0,
    filename: props.invoiceTax.invoice_no + '.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, letterRendering: true },
    jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' },
};

function generateInvoicePdf() {
    html2Pdf.value.generatePdf();
}

//pdf download progress
function onProgress(state) {
    if (state > 0 && state < 100) {
        isLoading.value = true;
    } else {
        isLoading.value = false;
    }
}

//function to calculate servicefee
function getServiceFee() {
    let serviceFee = 0;
    let totalserviceFee = 0;
    if (props.invoiceTax.tcs == 1) {
        serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
        totalserviceFee = serviceFee / 118 * 100;
    } else {
        totalserviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
        totalserviceFee = totalserviceFee / 118 * 100;
    }
    return totalserviceFee;
}

function getMumbaiTax() {
    let serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
    let mumbaiTax = serviceFee / 118 * 100;
    let finalMumbaiTax = mumbaiTax * 0.18;  //18% tax
    return finalMumbaiTax;
}
// echo number_format($acmd + ($acmd*18/100), 2);
function getTotalAmount(tcs) {
    let serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
    let eighteenPtax = serviceFee / 118 * 100;  //18% tax
    if (tcs == 1) {
        let totalAmount = eighteenPtax + (eighteenPtax * 18 / 100);
        return totalAmount;
    }
    else {
        return serviceFee;
    }
}

function getTcsAmount() {
    let tcsAmount = (props.invoiceTax.total_payable / 100) * 5;
    return parseFloat(tcsAmount);
}

//convert number to words
function convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
        let value = "";
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i +
                1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
}

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import 'flatpickr/dist/themes/material_orange.css';
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Invoice Preview" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="row invoice-preview">
                <!-- Invoice -->
                <div class="col-xl-9 col-md-8 col-12 mb-md-0 mb-4">
                    <div class="card invoice-preview-card">
                        <div class="card-body pb-0 pt-0">
                            <div
                                class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3 p-0">
                                <div class="mb-xl-0 mb-4">
                                    <div class="d-flex svg-illustration mb-3 gap-2">
                                        <span class="app-brand-logo demo">
                                            <img style="width:140px;" src="/storage/company_logos/company_logo.png"
                                                alt="logo">
                                        </span>
                                    </div>
                                    <span>
                                        <span v-html="props.agent?.address2"></span>
                                    </span>
                                </div>
                                <div class="pt-4">
                                    <h4>Tax Invoice</h4>
                                    <div class="mb-2">
                                        <span class="me-1">Invoice No:</span>
                                        <span class="fw-semibold">
                                            {{ props.invoiceTax.invoice_no }}
                                        </span>
                                    </div>
                                    <div>
                                        <span class="me-1">Invoice Date:</span>
                                        <span class="fw-semibold">
                                            {{ dayjs(props.invoiceTax?.created_at).format('Do MMM YYYY') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="my-0" />
                        <div class="card-body pt-0 pb-0">
                            <div class="row p-sm-3 p-0">
                                <div class="col-xl-6 col-md-12 col-sm-5 col-12 mb-xl-0 mb-md-4 mb-sm-0 mb-4">
                                    <h6 class="pb-0">Invoice To:</h6>
                                    <p class="mb-1" style="font-size: 14px; line-height: 1.4em;">{{
                                        props.invoiceTax.bookings.agent?.agency_name
                                    }}</p>
                                    <p class="mb-1" style="font-size: 14px; line-height: 1.4em;">{{
                                        props.invoiceTax.bookings.agent?.agency_address
                                    }}</p>
                                    <p class="mb-1" style="font-size: 14px; line-height: 1.4em;"><b>Tax ID (TIN):</b> {{
                                        props.invoiceTax.bookings.agent?.agency_TIN
                                    }}</p>
                                    <p class="mb-1" style="font-size: 14px; line-height: 1.4em;"><b>Email:</b> {{
                                        props.invoiceTax.bookings.agent?.agency_email
                                    }}
                                    </p>
                                    <p class="mb-1" style="font-size: 14px; line-height: 1.4em;"><b>PAN Number:</b> {{
                                        props.invoiceTax.bookings.agent?.pan_number
                                    }}
                                    </p>
                                </div>
                                <div class="col-xl-6 col-md-12 col-sm-7 col-12"
                                    style="font-size: 15px;letter-spacing: .5px; background-color: #e1f5fe; border-radius:3px; padding:25px;">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pe-3"><strong>Booking Number:</strong></td>
                                                <td><strong>{{ props.invoiceTax.bookings?.booking_no }}</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pe-3"><strong>Property Name:</strong></td>
                                                <td>{{ props.invoiceTax.bookings.hotel?.name }}</td>
                                            </tr>
                                            <tr>
                                                <td class="pe-3"><strong>Arrival Date:</strong></td>
                                                <td>{{
                                                    dayjs(props.invoiceTax.bookings?.arrival_date).format('ddd,\
                                                    Do MMM YYYY')
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pe-3"><strong>Departure Date:</strong></td>
                                                <td>{{
                                                    dayjs(props.invoiceTax.bookings?.departure_date).format('ddd,\
                                                    Do MMM YYYY')
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pe-3"><strong>Guest Name:</strong></td>
                                                <td>{{
                                                    props.invoiceTax.bookings?.client[0]?.title
                                                }}.{{ props.invoiceTax.bookings?.client[0]?.first_name }}
                                                    {{ props.invoiceTax.bookings?.client[0]?.last_name }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-active">
                                    <tr>
                                        <th style="font-size: 13px;">BOOKING DETAILS</th>
                                        <th style="font-size: 13px;">NO. OF ROOMS</th>
                                        <th style="font-size: 13px;">ROOM RATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="col-md-5">
                                            <span v-for="roomtype in props.invoiceTax.bookings?.booking_rooms">
                                                <span>{{ roomtype.room_category?.name }} <b>For</b> {{
                                                    roomtype.nights
                                                }} Nights </span><br>
                                            </span>
                                            <span v-if="props.invoiceTax.bookings.stay_type == 1"> <b>(Split
                                                    Stay)</b></span>
                                        </td>
                                        <td class="col-md-2">{{ props.invoiceTax.bookings.no_rooms }}</td>
                                        <td class="col-md-3"><b>{{ props.invoiceTax.currency }}</b> {{
                                            formatPrice(props.invoiceTax.room_rate)
                                        }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <br>
                            <div class="row">
                                <div class="col-md-6" style="padding-right:0;">
                                    <table class="table">
                                        <thead class="table-active">
                                            <tr>
                                                <th style="text-align: left; font-size: 13px;">
                                                    DESCRIPTION OF SERVICE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr valign=top>
                                                <td>
                                                    <b>HOTEL ACCOMMODATION CHARGES (Service Fee)</b>
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name == 'Mumbai'" valign=top>
                                                <td>
                                                    <b>Central GST @ 9%</b>
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name == 'Mumbai'" valign=top>
                                                <td>
                                                    <b>IGST @ 9%</b>
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name != 'Mumbai'" valign=top>
                                                <td>
                                                    <b>IGST @ 18%</b>
                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>
                                                    <b>TOTAL AMOUNT</b>
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.tcs == 1" valign=top>
                                                <td>
                                                    <b>TCS</b>
                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>

                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>
                                                    <b>Total Amount Payable (Accommodation Charges + Service Fees)</b>
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.tcs == 1" valign=top>
                                                <td>
                                                    <b>Accomodation Charges + TCS</b>
                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>
                                                    <b>Amount in words</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-6" style="padding-left:0;">
                                    <table class="table">
                                        <thead class="table-active">
                                            <tr>
                                                <th style="text-align: left; font-size: 13px;">TAXABLE
                                                    VALUE OF SUPPLY (Rs.)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getServiceFee()) }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name == 'Mumbai'" valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getMumbaiTax() / 2) }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name == 'Mumbai'" valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getMumbaiTax() / 2) }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.bookings.agent.city.name != 'Mumbai'" valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getMumbaiTax()) }}
                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getTotalAmount(props.invoiceTax.tcs)) }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.tcs == 1" valign=top>
                                                <td>
                                                    {{ formatPriceRoundOff(getTcsAmount()) }}
                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>

                                                </td>
                                            </tr>
                                            <tr valign=top>
                                                <td>
                                                    {{ formatPrice(props.invoiceTax.total_payable) }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.tcs == 1" valign=top>
                                                <td>
                                                    {{ formatPrice(parseFloat(props.invoiceTax.total_payable) +
                                                        getTcsAmount())
                                                    }}
                                                </td>
                                            </tr>
                                            <tr v-if="props.invoiceTax.tcs == 1" valign=top>
                                                <td>
                                                    {{ convertNumberToWords(parseFloat(props.invoiceTax.total_payable) +
                                                        getTcsAmount())
                                                    }}
                                                </td>
                                            </tr>
                                            <tr v-else valign=top>
                                                <td>
                                                    {{ convertNumberToWords(props.invoiceTax.total_payable) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td colspan="2" class="align-top px-4 py-3" style=" ">
                                            <p class="mb-3 col-md-6">
                                                <span class="me-1 fw-semibold" style="font-size: 14px;"><b>Arrange
                                                        Payment by Bank Transfers to
                                                        Our Bank Account in INR</b></span>
                                            </p>
                                            <span>
                                                <p>Account Name: PLAN ISLAND TRAVEL PVT LTD<br>
                                                    Bank Name: ICICI Bank<br>
                                                    Bank Account Number: 120205000974<br>
                                                    IFSC Code: ICIC0001202<br>
                                                    Branch: Shop No. 15, Kanakia Zillion, LBS Marg,<br>
                                                    Kurla (W), Mumbai-400070</p>
                                            </span>
                                        </td>
                                        <td>
                                            <p class="mb-2 fw-semibold"><b>SERVICE ACCOUNTING CODE: 998552</b></p>
                                            <p class="mb-2 fw-semibold"><b>GST IN: 27AAKCP7338P1ZJ</b></p>
                                            <p class="mb-2 fw-semibold"><b>PAN NUMBER: AAKCP7338P</b></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-4 col-12 invoice-actions"
                    v-if="$page.props.user.permissions.includes('download-tax-invoice')">
                    <div class="card">
                        <div class="card-body">
                            <button class="btn btn-label-info d-grid w-100 mb-3" @click="generateInvoicePdf()">
                                Download</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <Vue3Html2pdf :show-layout="false" :enable-download="true" :preview-modal="false" :manual-pagination="true"
            pdf-content-width="1500px" :html-to-pdf-options="options" @progress="onProgress($event)" ref="html2Pdf">
            <template v-slot:pdf-content>
                <TaxInvoicePdf :invoiceTax="props.invoiceTax" :agent="props.agent" />
            </template>
        </Vue3Html2pdf>
    </AppLayout>
</template>